/* ============
 * Recipe Type Transformer
 * ============
 *
 * The transformer for the recipeType.
 */

import Transformer from './transformer';

export default class RecipeTypeTransformer extends Transformer {

  static fetch(recipeType) {
    return {
      id: recipeType.id,
      name: recipeType.name,
    };
  }

  static send(recipeType) {
    return {
      id: recipeType.id,
      name: recipeType.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/recipeType.js